// extracted by mini-css-extract-plugin
export default {"base":"vp_SJ0wn","text":"vp_nkPNH","language":"vp_iLGP4","title":"vp_Gi3Ra","description":"vp_pQvUS","questionCount":"vp_d1Qv_","start":"vp_KD153"};